import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import type {
  CreateDashboardSavedViewRequest,
  UpdateDashboardSavedViewRequest
} from '../Types/Requests/DashboardSavedViewRequests'
import type { DashboardSavedView } from '../Types/Responses/DashboardSavedViewResponses'

export default class DashboardSavedViewService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/dashboard-saved-views'
  }

  async list(companyId: number): Promise<DashboardSavedView[]> {
    try {
      const { data } = await request.get<DashboardSavedView[]>(this.getCompletePath(), {
        companyId
      })
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as visões salvas')
    }
  }

  async create(body: CreateDashboardSavedViewRequest): Promise<DashboardSavedView> {
    try {
      const { data } = await request.post<DashboardSavedView>(this.getCompletePath(), body)
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível salvar a visão')
    }
  }

  async update(id: number, body: UpdateDashboardSavedViewRequest): Promise<DashboardSavedView> {
    try {
      const { data } = await request.patch<DashboardSavedView>(this.getCompletePath(`/${id}`), body)
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível atualizar a visão')
    }
  }

  async remove(id: number): Promise<void> {
    try {
      await request.delete(this.getCompletePath(`/${id}`))
    } catch (e) {
      throw this.handleError(e, 'Não foi possível excluir a visão')
    }
  }
}
